// extracted by mini-css-extract-plugin
export default {"labelWrapper":"Active_labelWrapper__7RwVS","buttonWrapper":"Active_buttonWrapper__SauJy"};